module.exports = __webpack_public_path__ + "static/img/taihe.5497582c.png";